import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FormInstance } from 'antd/es/form';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import Configs from 'config';
import { get } from 'lodash';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import { updateMentee, getCurrentMentee } from 'libs/api/user';
import { useDataApi } from 'libs/hooks';
import { showNotification, filteredFileNames } from 'libs/utils';
import { TMenteeUpdate, TUser, TMentee, setUserInfo } from 'modules/user';
import { CUploadFileProps } from 'constants/base.const';
import { Upload, message, Divider, Button, Form, Input, Typography } from 'antd';

const { Title, Text } = Typography;
type TMenteeEditProps = {
  form: FormInstance;
};
const MenteeEdit = ({ form }: TMenteeEditProps) => {
  const [{ data, loading }] = useDataApi<TMentee>(getCurrentMentee.bind(null));
  const [activateChecked, setActivateChecked] = useState(false);
  const dispatch = useDispatch();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [uploadVisible, setUploadVisible] = useState(true);

  useEffect(() => {
    // form.setFieldsValue({
    //   activate_intern: get(data, "activate_intern"),
    //   gpa: get(data, "gpa"),
    //   available_working_date_from:
    //     get(data, "available_working_date_from") &&
    //     moment(get(data, "available_working_date_from"), CDefaultDateFormat),
    //   available_working_date_to:
    //     get(data, "available_working_date_to") &&
    //     moment(get(data, "available_working_date_to"), CDefaultDateFormat),
    // });
    if (get(data, 'resume_file')) {
      form.setFieldsValue({
        resume_files: [
          {
            uid: get(data, 'resume_file.id'),
            status: 'done',
            name: get(data, 'resume_file.file_name'),
            absolute_url: get(data, 'resume_file.absolute_url'),
          },
        ],
      });
      setUploadVisible(false);
    } else {
      setUploadVisible(true);
    }
    // setActivateChecked(get(data, "activate_intern"));
  }, [data]);

  function handleActivateChecked(checked: boolean) {
    setActivateChecked(checked);
  }

  function onClickSubmit() {
    form
      .validateFields()
      .then((value) => {
        (async (value: TMenteeUpdate) => {
          try {
            setSubmitButtonDisabled(true);
            const response = await updateMentee({
              ...value,
              resume_file_ids: filteredFileNames(form.getFieldValue('resume_files')),
            } as TMenteeUpdate);
            dispatch(setUserInfo(get(response, 'data.user') as TUser));

            showNotification('success', '회원정보가 수정되었습니다');
          } catch (e) {
            handleFieldError(e, form);
            throw e;
          } finally {
            setSubmitButtonDisabled(false);
          }
        })(value as TMenteeUpdate);
      })
      .catch((errorInfo) => {
        moveToFirstError(form, errorInfo.errorFields);
      });
  }

  return (
    <Input.Group className='form-inline' style={{ marginTop: '40px' }}>
      <Divider />

      <div className='content-title'>이력서</div>
      <Form.Item
        name={'resume_files'}
        className='form-item'
        rules={[
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (getFieldValue('activate_intern') === true && (!value || value?.length == 0)) {
                return Promise.reject('인턴지원을 위해 이력서를 업로드해주세요');
              }
              return Promise.resolve();
            },
          }),
        ]}
        shouldUpdate={(prevValues, currentValues) => prevValues.resume_files !== currentValues.resume_files}
        valuePropName='fileList'
        label='이력서 업로드'
        getValueFromEvent={(e: UploadChangeParam) => (Array.isArray(e) ? e : e && e?.fileList)}
      >
        <Upload
          name='file'
          {...CUploadFileProps}
          action={`${Configs.API_HOST}/resume/file`}
          onChange={(info: UploadChangeParam) => {
            const { status } = info.file;

            if (status === 'done') {
              message.success(`${info.file.name} 업로드에 성공했습니다.`);
              setUploadVisible(false);
            } else if (status === 'error') {
              message.error(`${info.file.name} 업로드에 실패했습니다.`);
            } else if (status === 'removed') {
              if (info.fileList.length === 0) {
                setUploadVisible(true);
              }
            }
          }}
        >
          {uploadVisible === true && (
            <div style={{ float: 'right' }} className='input-suffix'>
              업로드
            </div>
          )}
        </Upload>
      </Form.Item>

      {/* <div className="content-title">근무 가능일</div>
      <Form.Item className="form-item" noStyle={true}>
        <Row>
          <Form.Item name={"activate_intern"}>
            <Switch
              //Determine whether the Switch is checked
              checked={activateChecked}
              //Trigger when the checked state is changing
              onChange={handleActivateChecked}
              //The content to be shown when the state is checked
              checkedChildren="ON"
              //The content to be shown when the state is unchecked
              unCheckedChildren="OFF"
            />
          </Form.Item>
          <Form.Item>
            <Text style={{ fontSize: "12px" }} strong>
              인턴지원 설정하기.
            </Text>
          </Form.Item>
        </Row>
      </Form.Item> */}
      {/* <Form.Item
        name={"gpa"}
        className="form-item"
        label="평균학점(4.0 만점 기준으로 작성 부탁 드립니다.)"
      >
        <InputNumber
          precision={2}
          size="large"
          placeholder="최신 평균 학점을 입력해주세요"
        />
      </Form.Item>
      <Form.Item noStyle>
        <Input.Group>
          <Row gutter={[8, 8]}>
            <Col span={12}>
              <Form.Item
                name={"available_working_date_from"}
                className="form-item"
                label="근무 가능 시작일"
              >
                <DatePicker
                  format={CDefaultDateFormat}
                  placeholder="시작일 선택"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name={"available_working_date_to"}
                className="form-item"
                label="종료일"
              >
                <DatePicker
                  format={CDefaultDateFormat}
                  placeholder="종료일 선택"
                />
              </Form.Item>
            </Col>
          </Row>
        </Input.Group>
      </Form.Item> */}
      <Form.Item shouldUpdate={true} className='form-button'>
        {() => (
          <Button
            type='primary'
            htmlType='submit'
            size='large'
            style={{ float: 'right', maxWidth: '100px' }}
            onClick={onClickSubmit}
            loading={submitButtonDisabled}
          >
            저장
          </Button>
        )}
      </Form.Item>
    </Input.Group>
  );
};

export default MenteeEdit;
